import { render } from "./DocumentTitle.vue?vue&type=template&id=3cee27ca"
import script from "./DocumentTitle.vue?vue&type=script&lang=js"
export * from "./DocumentTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__